import React from 'react';
import * as PropTypes from 'prop-types';
import { Link } from '@material-ui/core';
import styles from './Header.module.less';

const Header = ({ blackBgColor }) => {
  return (
    <div className={`${styles.header} ${blackBgColor && styles['black-bg']}`}>
      <Link className={styles.logo} href='/portal' underline='none'>
        ITT/XM Platform
      </Link>
    </div>
  );
};

Header.defaultProps = {
  blackBgColor: false
};

Header.propTypes = {
  blackBgColor: PropTypes.bool
};

export default Header;
